(() => {
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => [...root.querySelectorAll(selector)];

  const openMenu = () => {
    const menu = q('[data-pj-mobile-menu]');
    if (!menu) return;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
    q('[data-pj-menu-close]', menu)?.focus();
  };

  const closeMenu = () => {
    const menu = q('[data-pj-mobile-menu]');
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
    q('[data-pj-menu-open]')?.focus();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-pj-menu-open]')) openMenu();
    if (event.target.closest('[data-pj-menu-close]')) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let revealObserver;

  const getRevealObserver = () => {
    if (revealObserver || reducedMotion || !('IntersectionObserver' in window)) return revealObserver;

    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    return revealObserver;
  };

  const reveal = (root = document) => {
    const items = [];
    if (root.matches?.('.pj-reveal')) items.push(root);
    items.push(...qa('.pj-reveal', root));

    items.forEach((item) => {
      if (item.dataset.pjRevealBound === 'true') return;
      item.dataset.pjRevealBound = 'true';

      if (reducedMotion || !('IntersectionObserver' in window)) {
        item.classList.add('is-visible');
        return;
      }

      getRevealObserver().observe(item);
    });
  };

  const start = () => reveal(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  document.addEventListener('shopify:section:reorder', () => reveal(document));
  document.addEventListener('shopify:block:select', (event) => {
    event.target.closest('.pj-reveal')?.classList.add('is-visible');
  });
})();